const common = {
  "nav.home": "Inicio",
  "nav.productSellMore": "Taller Vende Más",
  "nav.productPrompts": "1500+ Prompts",
  "nav.productPhoenix": "Mentoring Fenix Lite",
  "nav.productTrafficPro": "Traffic Pro",
  "nav.productTrafficMaster": "Traffic Master",
  "nav.productWebDesign": "Diseño Web",
  "nav.productsTitle": "Productos",
  "nav.services": "Servicios",
  "nav.academy": "Academia",
  "nav.portfolio": "Portafolio",
  "nav.about": "Nosotros",
  "nav.resources": "Recursos",
  "nav.contact": "Contacto",
  "nav.bookCall": "Agenda una Asesoría",
  "nav.toggleMenu": "Abrir menú",

  "footer.tagline": "Transformando Negocios en Marcas Rentables con Marketing, Inteligencia Artificial y Automatización. Construimos sistemas que generan más clientes y más ventas.",
  "footer.services": "Servicios",
  "footer.products": "Productos",
  "footer.company": "Empresa",
  "footer.marketingStrategy": "Estrategia de Marketing",
  "footer.metaAds": "Meta Ads",
  "footer.googleAds": "Google Ads",
  "footer.webDesign": "Diseño Web",
  "footer.automation": "Automatización",
  "footer.aiSolutions": "Soluciones IA",
  "footer.sellMoreWorkshop": "Taller Vende Más",
  "footer.prompts": "1500+ Prompts",
  "footer.phoenixLite": "Phoenix Lite",
  "footer.trafficPro": "Traffic Pro",
  "footer.trafficMaster": "Traffic Master",
  "footer.webDesignPlans": "Planes Web",
  "footer.aboutUs": "Sobre Nosotros",
  "footer.successStories": "Casos de Éxito",
  "footer.contact": "Contacto",
  "footer.rights": "Todos los derechos reservados.",
  "footer.privacy": "Política de Privacidad",
  "footer.terms": "Términos de Servicio",

  "hero.tag": "Agencia de Marketing Digital Impulsada por IA",
  "hero.mainTitlePart1": "Construimos Sistemas Digitales que Generan",
  "hero.mainTitleHighlight1": "Clientes",
  "hero.mainTitlePart2": "y",
  "hero.mainTitleHighlight2": "Ventas",
  "hero.mainTitlePart3": "Todos los Días.",
  "hero.subheadline": "Combinamos estrategia, publicidad digital, diseño web, automatización e inteligencia artificial para construir un ecosistema de crecimiento que genera resultados medibles.",
  "hero.ctaPrimary": "Quiero una Asesoría Gratuita",
  "hero.ctaSecondary": "Ver Cómo Trabajamos",
  "hero.trust1": "Estrategias Personalizadas",
  "hero.trust2": "Resultados Medibles",
  "hero.trust3": "Automatización Inteligente",
  "hero.trust4": "Crecimiento Escalable",
  "hero.scroll": "Desliza",

  "stats.businesses": "Negocios Ayudados",
  "stats.satisfaction": "Satisfacción de Clientes",
  "stats.revenue": "Ingresos Generados (USD)",
  "stats.experience": "Años de Experiencia",

  "services.tag": "Por Qué Elegirnos",
  "services.title": "Todo lo que Necesitas para",
  "services.titleHighlight": "Escalar tu Negocio",
  "services.subtitle": "De la estrategia a la ejecución, brindamos un ecosistema completo de servicios de marketing diseñados para un crecimiento medible.",
  "services.strategy": "Estrategia de Marketing",
  "services.strategyDesc": "Estrategias basadas en datos adaptadas a tus objetivos de negocio. Analizamos tu mercado, competidores y audiencia para construir una hoja de ruta hacia el crecimiento sostenible.",
  "services.metaAds": "Meta Ads",
  "services.metaAdsDesc": "Campañas de alto rendimiento en Facebook e Instagram. Optimizamos segmentación, creatividades y presupuestos para maximizar el ROAS y reducir costos de adquisición.",
  "services.googleAds": "Google Ads",
  "services.googleAdsDesc": "Campañas de Search, Display y YouTube que capturan clientes de alta intención. Dominamos tu nicho con segmentación de precisión.",
  "services.automation": "Automatización",
  "services.automationDesc": "Optimiza tus operaciones con flujos n8n, integraciones CRM y automatizaciones inteligentes que ahorran tiempo y reducen el trabajo manual.",
  "services.ai": "Inteligencia Artificial",
  "services.aiDesc": "Aprovecha chatbots con IA, analítica predictiva y creación inteligente de contenido para estar por delante de tus competidores y deleitar a tus clientes.",
  "services.webDesign": "Diseño Web Premium",
  "services.webDesignDesc": "Sitios web enfocados en conversión que cargan rápido, se ven increíbles y convierten visitantes en clientes. Construidos con las últimas tecnologías.",
  "services.funnels": "Embudos de Venta",
  "services.funnelsDesc": "Embudos diseñados para guiar prospectos desde el descubrimiento hasta la compra. Cada paso optimizado para máxima conversión.",
  "services.leads": "Generación de Leads",
  "services.leadsDesc": "Sistemas multicanal de generación de leads que llenan tu pipeline constantemente con prospectos calificados y listos para comprar.",
  "services.learnMore": "Saber más",

  "products.tag": "Nuestros Productos",
  "products.title": "Soluciones Que",
  "products.titleHighlight": "Generan Resultados",
  "products.subtitle": "Elige la solución adecuada para la etapa y objetivos de tu negocio.",
  "products.popular": "Popular",
  "products.sellMore": "Taller Vende Más",
  "products.sellMorePrice": "$9.9 USD",
  "products.sellMoreDesc": "Aprende a crear tus campañas publicitarias en tres etapas, investigación de mercado, creación de anuncios con IA, creación de campaña y lectura de métricas.",
  "products.prompts": "1500+ Prompts Publicitarios",
  "products.promptsPrice": "$7.9 USD",
  "products.promptsDesc": "Prompts de IA listos para usar en anuncios de Meta, Google y TikTok que aumentan tu visualización.",
  "products.phoenix": "Mentoring Fenix Lite",
  "products.phoenixPrice": "$67 USD",
  "products.phoenixDesc": "Mentoría personalizada para elevar tus habilidades de marketing y estrategia de negocio.",
  "products.trafficPro": "Traffic Pro",
  "products.trafficProPrice": "$137 USD",
  "products.trafficProDesc": "Sistema de generación de tráfico hecho para que tu negocio tenga más venta.",
  "products.trafficMaster": "Traffic Master",
  "products.trafficMasterPrice": "$470 USD/mes",
  "products.trafficMasterDesc": "Gestión de tráfico a nivel empresarial con estrategias publicitarias y de parrilla de contenidos.",
  "products.webDesign": "Diseño Web Premium",
  "products.webDesignPrice": "Desde $277 USD",
  "products.webDesignDesc": "Sitios web optimizados para conversión que convierten visitantes en clientes.",
  "products.buyNow": "Comprar Ahora",
  "products.download": "Descargar",
  "products.joinNow": "Únete Ahora",
  "products.hireNow": "Contratar Ahora",
  "products.bookConsultation": "Agendar Consultoría",
  "products.viewPlans": "Ver Planes",

  "portfolio.tag": "Portafolio",
  "portfolio.title": "Trabajo Que",
  "portfolio.titleHighlight": "Habla por Sí Solo",
  "portfolio.subtitle": "Resultados reales de clientes reales. Esto es lo que pasa cuando la estrategia se une a la ejecución.",
  "portfolio.project1": "Rediseño E-Commerce",
  "portfolio.project1Cat": "Diseño Web + Meta Ads + IA",
  "portfolio.project1Desc": "Transformamos una tienda online en una máquina de ventas.",
  "portfolio.project1Stat": "Aumento de Ingresos",
  "portfolio.project2": "Sistema de Leads",
  "portfolio.project2Cat": "Automatización",
  "portfolio.project2Desc": "Construimos un embudo automatizado de leads que entrega más de 200 leads calificados mensuales.",
  "portfolio.project2Stat": "Leads Mensuales",
  "portfolio.project3": "Transformación de Marca",
  "portfolio.project3Cat": "Estrategia + Contenido IA",
  "portfolio.project3Desc": "Reposicionamos un negocio tradicional como una marca digital-first con contenido potenciado por IA.",
  "portfolio.project3Stat": "Reconocimiento de Marca",

  "success.tag": "Casos de Éxito",
  "success.title": "Resultados Reales,",
  "success.titleHighlight": "Crecimiento Real",
  "success.subtitle": "Descubre cómo hemos ayudado a empresas a transformar su marketing y escalar sus ingresos.",
  "success.ecommerce": "E-Commerce",
  "success.saas": "Diseño Web",
  "success.professional": "Servicios Profesionales",
  "success.challenge": "El Desafío",
  "success.strategy": "La Estrategia",
  "success.execution": "La Ejecución",
  "success.results": "Los Resultados",
  "success.prev": "Anterior",
  "success.next": "Siguiente",
  "success.story1Challenge": "Un negocio retail luchando con la disminución del tráfico presencial y baja presencia online.",
  "success.story1Strategy": "Desarrollamos una estrategia digital multicanal combinando Meta Ads, página web y un nuevo sitio e-commerce.",
  "success.story1Execution": "Lanzamos campañas segmentadas, construimos landing pages optimizadas e implementamos automatización para tu empresa.",
  "success.story1Results": "Aumento del 340% en ingresos online en 6 meses. Más de 200 nuevos leads calificados por mes.",
  "success.story1Quote": "Santi y su equipo transformaron nuestro negocio por completo. Pasamos de estar estancados a prosperar en cuestión de meses.",
  "success.story1Name": "María González",
  "success.story1Role": "CEO, Empresa de moda.",
  "success.story2Challenge": "Posicionar una marca en la web para aumentar las ventas.",
  "success.story2Strategy": "Implementamos una estrategia basada en datos con pujas optimizadas por IA y embudos de retargeting.",
  "success.story2Execution": "Construimos scoring de leads automatizado, desplegamos smart bidding y optimizamos landing pages con A/B testing.",
  "success.story2Results": "Reducción del 62% en costo por adquisición mientras escalamos de 200 a 1,500 registros mensuales.",
  "success.story2Quote": "Los sistemas que Santi construyó siguen generando resultados. Nuestra trayectoria de crecimiento cambió completamente después de trabajar con él.",
  "success.story2Name": "Carlos Mendoza",
  "success.story2Role": "Fundador, Empresa de tecnología.",
  "success.story3Challenge": "Una firma de servicios profesionales necesitaba establecer autoridad y generar leads de alto valor.",
  "success.story3Strategy": "Creamos una estrategia de contenido para construir autoridad con contenido IA, SEO y automatización en Meta ads.",
  "success.story3Execution": "Publicamos más de 50 artículos optimizados, crecimos el seguimiento en Meta ads y construimos un sistema automatizado.",
  "success.story3Results": "Conseguimos 15 clientes de alto valor por más de $450K USD en el primer año. Aumento del 520% en tráfico orgánico.",
  "success.story3Quote": "Antes invertíamos en publicidad sin una estrategia clara. Con Santi Ospina Marketer construimos un sistema completo que integra campañas, automatización y una página web optimizada. Hoy tenemos un proceso comercial mucho más organizado y resultados medibles.",
  "success.story3Name": "Ana Lucía Ruiz",
  "success.story3Role": "Socia Directora, Inmobiliria.",

  "testimonials.tag": "Testimonios",
  "testimonials.title": "Lo Que Dicen",
  "testimonials.titleHighlight": "Nuestros Clientes",
  "testimonials.subtitle": "No creas solo nuestra palabra. Esto es lo que dicen los dueños de negocio sobre trabajar con nosotros.",
  "testimonials.prev": "Testimonio anterior",
  "testimonials.next": "Siguiente testimonio",
  "testimonials.1quote": "Trabajar con Santi Ospina cambió el juego para nuestro negocio. En solo 3 meses, nuestro ROAS en Meta Ads pasó de 1.2x a 4.8x. Los sistemas de automatización que construyeron nos ahorran más de 20 horas cada semana.",
  "testimonials.1name": "Diego Ramírez",
  "testimonials.1role": "CEO, Empresa de tecnología.",
  "testimonials.2quote": "El sitio web que Santi diseñó para nosotros no solo se ve hermoso — convierte. Nuestra tasa de conversión saltó del 1.8% al 6.2%. El ROI ha sido increíble. La mejor inversión que hemos hecho en años.",
  "testimonials.2name": "Laura Castillo",
  "testimonials.2role": "Directora de Marketing, Empresa de suplementos.",
  "testimonials.3quote": "Después de años luchando con Meta Ads, el equipo de Santi optimizó nuestras campañas y redujo nuestro CPA en un 65% mientras duplicaba el volumen de leads. Las herramientas de IA que implementaron son revolucionarias.",
  "testimonials.3name": "Andrés Mejía",
  "testimonials.3role": "Fundador, empresa de fritos",
  "testimonials.4quote": "Santi no solo hace marketing — construye sistemas. Toda nuestra generación de leads ahora está automatizada. Nos despertamos con leads calificados en nuestro inbox cada mañana. Absolutamente transformador.",
  "testimonials.4name": "Carolina Vargas",
  "testimonials.4role": "Dueña, consultorio jurídico",
  "testimonials.5quote": "El sistema Traffic Pro generó más leads en nuestro primer mes que en los 6 meses anteriores combinados. El enfoque de Santi hacia el marketing basado en datos está en otro nivel.",
  "testimonials.5name": "Felipe Torres",
  "testimonials.5role": "Director, empresa especialista en construcción",

  "process.tag": "Nuestro Proceso",
  "process.title": "Cómo",
  "process.titleHighlight": "Entregamos Resultados",
  "process.subtitle": "Un framework probado de 7 pasos que convierte tu inversión en marketing en crecimiento empresarial medible.",
  "process.step1": "Descubrimiento",
  "process.step1Desc": "Nos sumergimos en tu negocio, audiencia, competidores y metas para entender exactamente qué impulsa el crecimiento.",
  "process.step2": "Estrategia",
  "process.step2Desc": "Creamos una estrategia de marketing respaldada por datos, adaptada a tu posición única, presupuesto y objetivos de crecimiento.",
  "process.step3": "Diseño",
  "process.step3Desc": "Nuestro equipo creativo diseña activos, landing pages y creatividades que capturan la atención y la convierten en ventas reales.",
  "process.step4": "Desarrollo",
  "process.step4Desc": "Construimos sitios web de alto rendimiento, embudos y sistemas de automatización diseñados para velocidad y conversión.",
  "process.step5": "Lanzamiento",
  "process.step5Desc": "Las campañas se lanzan con segmentación de precisión, presupuestos optimizados y dashboards de seguimiento en tiempo real.",
  "process.step6": "Optimización",
  "process.step6Desc": "Pruebas A/B continuas, análisis de datos y mejoras iterativas para maximizar el ROAS y reducir costos de adquisición.",
  "process.step7": "Escalamiento",
  "process.step7Desc": "Una vez que las métricas son rentables, escalamos agresivamente a través de canales manteniendo la eficiencia.",

  "cta.title": "¿Listo para",
  "cta.titleHighlight": "Escalar tu Negocio",
  "cta.titleEnd": "?",
  "cta.subtitle": "Construyamos los sistemas de marketing que transformarán tu negocio. Agenda una consultoría gratuita y descubre lo que es posible.",
  "cta.button1": "Agendar Consultoría",
  "cta.button2": "Contactar por WhatsApp",
  "cta.trust1": "100% Garantía de Satisfacción",
  "cta.trust2": "Consultoría de 30 Min Gratis",
  "cta.trust3": "Resultados en 30 Días o Menos",

  "contact.tag": "Contáctanos",
  "contact.title": "Hablemos",
  "contact.titleHighlight": "Sobre tu Negocio",
  "contact.subtitle": "",
  "contact.contactSubtitle": "Agenda una consultoría gratuita de 15 minutos. Discutiremos tus metas, desafíos y cómo podemos ayudarte a escalar.",
  "contact.whatsapp": "WhatsApp",
  "contact.email": "Email",
  "contact.location": "Ubicación",
  "contact.locationValue": "Colombia - Atendiendo Clientes en Todo el Mundo",
  "contact.formTitle": "Solicita tu Consultoría Gratuita",
  "contact.fullName": "Nombre Completo",
  "contact.namePlaceholder": "Tu nombre completo",
  "contact.emailLabel": "Correo Electrónico",
  "contact.emailPlaceholder": "tu@empresa.com",
  "contact.company": "Empresa",
  "contact.companyPlaceholder": "Nombre de tu empresa",
  "contact.phone": "Teléfono",
  "contact.phonePlaceholder": "300 000 0000",
  "contact.countryCode": "Indicativo",
  "contact.service": "Servicio de Interés",
  "contact.servicePlaceholder": "Selecciona un servicio",
  "contact.serviceStrategy": "Estrategia de Marketing",
  "contact.serviceMetaAds": "Meta Ads",
  "contact.serviceGoogleAds": "Google Ads",
  "contact.serviceAutomation": "Automatización e IA",
  "contact.serviceWebDesign": "Diseño Web",
  "contact.serviceTrafficPro": "Traffic Pro",
  "contact.serviceTrafficMaster": "Traffic Master",
  "contact.serviceMentoring": "Phoenix Lite Mentoring",
  "contact.serviceOther": "Otro",
  "contact.message": "Mensaje",
  "contact.messagePlaceholder": "Cuéntanos sobre tu negocio y objetivos...",
  "contact.charLimit": "Máximo 500 caracteres",
  "contact.submit": "Agendar Mi Consultoría Gratuita",
  "contact.sending": "Enviando...",
  "contact.success": "¡Gracias! Te contactaremos dentro de 24 horas.",
  "contact.networkError": "Error de red. Intenta de nuevo.",

  "lang.es": "ES",
  "lang.en": "EN",

  "phoenix.badge": "🔥 Programa Exclusivo 3 sesiones por",
  "phoenix.heroTitle": "Mentoring Fenix Lite",
  "phoenix.heroHeadline": "Aprende a crear campañas rentables con Inteligencia Artificial y Meta Ads trabajando directamente conmigo.",
  "phoenix.heroSubtitle": "Esta no es una mentoría tradicional. Durante tres sesiones privadas construiremos juntos una estrategia personalizada para tu negocio. Aprenderás a investigar tu mercado utilizando Inteligencia Artificial, crear anuncios profesionales y lanzar campañas que realmente generen clientes.",
  "phoenix.feature1": "Mentoría 100% Personalizada",
  "phoenix.feature2": "Trabajo 1 a 1",
  "phoenix.feature3": "Casos Reales",
  "phoenix.feature4": "Cupos Limitados",
  "phoenix.price": "171 USD",
  "phoenix.pricePerSession": "CADA SESIÓN A 67 USD",
  "phoenix.ctaPrimary": "Reservar mi Cupo",
  "phoenix.ctaSecondary": "Ver Programa",
  "phoenix.ctaBuySessions": "Quiero adquirir las 3 sesiones",
  "phoenix.trust1": "Pago Seguro",
  "phoenix.trust2": "Acceso Inmediato",
  "phoenix.trust3": "Atención Personalizada",

  "phoenix.transformationTag": "De principiante a estratega digital",
  "phoenix.transformationTitle": "Al finalizar el Programa Fenix Lite™ serás capaz de:",
  "phoenix.transformation1": "Diseñar una estrategia profesional",
  "phoenix.transformation2": "Utilizar Inteligencia Artificial para investigar mercados",
  "phoenix.transformation3": "Crear anuncios de alto impacto",
  "phoenix.transformation4": "Configurar campañas profesionales",
  "phoenix.transformation5": "Analizar métricas correctamente",
  "phoenix.transformation6": "Escalar campañas rentables",

  "phoenix.methodTag": "Método Phoenix™",
  "phoenix.phase1Title": "Diagnóstico Estratégico",
  "phoenix.phase1Time": "2 horas",
  "phoenix.phase1Item1": "Análisis del negocio",
  "phoenix.phase1Item2": "Cliente ideal",
  "phoenix.phase1Item3": "Competencia",
  "phoenix.phase1Item4": "Objetivos",
  "phoenix.phase1Item5": "Diseño de estrategia",
  "phoenix.phase1Desc": "Terminaremos esta sesión con una estrategia completamente definida para tu negocio.",
  "phoenix.phase2Title": "Inteligencia Artificial Aplicada",
  "phoenix.phase2Time": "2 horas",
  "phoenix.phase2Item1": "Investigación con IA",
  "phoenix.phase2Item2": "Prompts",
  "phoenix.phase2Item3": "Creación de anuncios",
  "phoenix.phase2Item4": "Copywriting",
  "phoenix.phase2Item5": "Creativos",
  "phoenix.phase2Item6": "Optimización",
  "phoenix.phase2Desc": "Aprenderás a utilizar la Inteligencia Artificial para acelerar todo el proceso de creación de campañas.",
  "phoenix.phase3Title": "Implementación Profesional",
  "phoenix.phase3Time": "2 horas",
  "phoenix.phase3Item1": "Configuración Meta Ads",
  "phoenix.phase3Item2": "Campañas",
  "phoenix.phase3Item3": "Eventos",
  "phoenix.phase3Item4": "Pixel",
  "phoenix.phase3Item5": "Métricas",
  "phoenix.phase3Item6": "Optimización",
  "phoenix.phase3Item7": "Escalamiento",
  "phoenix.phase3Desc": "Terminaremos con una campaña completamente funcional y lista para generar resultados.",

  "phoenix.includesTag": "¿Qué incluye?",
  "phoenix.includes1": "3 sesiones privadas",
  "phoenix.includes2": "Más de 6 horas de acompañamiento",
  "phoenix.includes3": "Implementación sobre tu propio negocio",
  "phoenix.includes4": "Revisión de campañas",
  "phoenix.includes5": "Acceso directo al mentor",
  "phoenix.includes6": "Material descargable",
  "phoenix.includes7": "Plantillas",
  "phoenix.includes8": "Recursos",

  "phoenix.bonusTag": "Bonos Exclusivos",
  "phoenix.bonusPromptsTitle": "1500+ Prompts Publicitarios",
  "phoenix.bonusPromptsValue": "7.9 USD",
  "phoenix.bonusPromptsDesc": "Pack completo de prompts de IA listos para usar en Meta, Google y TikTok. Acelera la creación de tus anuncios con copywriting profesional y creativos optimizados.",
  "phoenix.bonusLabel": "Valor Comercial",
  "phoenix.bonusHeading": "Un regalo que <span>acelera</span> tu aprendizaje.",

  "phoenix.pricingTag": "Valor del Programa",
  "phoenix.pricingMentoring": "Mentoría",
  "phoenix.pricingMentoringNormal": "Mentoría precio normal",
  "phoenix.pricingPrompts": "1500+ Prompts Publicitarios",
  "phoenix.pricingMentoringNormalValue": "234 USD",
  "phoenix.pricingPromptsValue": "7.9 USD",
  "phoenix.pricingTotal": "Total",
  "phoenix.pricingToday": "Hoy",
  "phoenix.pricingSave": "Ahorras 75.9 USD",

  "phoenix.forYouTag": "¿Esta mentoría es para ti?",
  "phoenix.yesTitle": "SÍ, es para ti si...",
  "phoenix.yes1": "Tienes un negocio",
  "phoenix.yes2": "Quieres aprender Meta Ads",
  "phoenix.yes3": "Quieres usar IA",
  "phoenix.yes4": "Quieres atraer más clientes",
  "phoenix.yes5": "Quieres dejar de improvisar",
  "phoenix.noTitle": "NO, si...",
  "phoenix.no1": "Buscas resultados sin implementar",
  "phoenix.no2": "No tienes tiempo para aprender",
  "phoenix.no3": "No quieres aplicar estrategias",

  "phoenix.aboutTag": "¿Por qué aprender conmigo?",
  "phoenix.aboutTitle": "Santiago Ospina",
  "phoenix.aboutRole": "Mentor & Estratega Digital",
  "phoenix.aboutBio": "Más de 5 años de experiencia ayudando a emprendedores y negocios a escalar sus ventas utilizando Meta Ads e Inteligencia Artificial. He trabajado con más de 100 clientes en diferentes industrias, combinando estrategia de marketing, automatización y tecnología para crear sistemas que generan resultados predecibles.",
  "phoenix.aboutSkill1": "Meta Ads",
  "phoenix.aboutSkill2": "Inteligencia Artificial",
  "phoenix.aboutSkill3": "Estrategia de Marketing",
  "phoenix.aboutSkill4": "Automatización",
  "phoenix.aboutSkill5": "Diseño Web",
  "phoenix.aboutSkill6": "Embudos de Venta",
  "phoenix.aboutFocus": "Enfoque en aprendizaje personalizado e implementación real.",

  "phoenix.resultsTag": "Resultados Esperados",
  "phoenix.results1": "Campañas profesionales",
  "phoenix.results2": "Mayor confianza",
  "phoenix.results3": "Procesos automatizados",
  "phoenix.results4": "Mejor ROAS",
  "phoenix.results5": "Más clientes",
  "phoenix.results6": "Mayor productividad",

  "phoenix.faqTag": "Preguntas Frecuentes",
  "phoenix.faq1Q": "¿Cómo funciona el Programa Phoenix Lite?",
  "phoenix.faq1A": "Son tres sesiones privadas de 2 horas cada una, donde trabajamos directamente sobre tu negocio. En la primera sesión hacemos un diagnóstico y diseñamos la estrategia. En la segunda te enseño a usar Inteligencia Artificial para crear anuncios. En la tercera configuramos juntos tus campañas en Meta Ads.",
  "phoenix.faq2Q": "¿Necesito experiencia previa en Meta Ads?",
  "phoenix.faq2A": "No. El programa está diseñado tanto para principiantes como para personas con algo de experiencia. Partimos desde cero y avanzamos a tu ritmo.",
  "phoenix.faq3Q": "¿Cuánto tiempo tengo para agendar las sesiones?",
  "phoenix.faq3A": "Tienes hasta 60 días desde la compra para agendar y completar las tres sesiones. Te recomiendo espaciarlas con un espacio de tres días por sesión, para que puedas implementar lo aprendido.",
  "phoenix.faq4Q": "¿Las sesiones son grabadas?",
  "phoenix.faq4A": "Sí, todas las sesiones son grabadas y tendrás acceso a las grabaciones de por vida, junto con todo el material descargable.",
  "phoenix.faq5Q": "¿Qué necesito tener listo para la primera sesión?",
  "phoenix.faq5A": "Solo necesitas tu computador, acceso a internet y muchas ganas de aprender. Idealmente tener tu cuenta de Facebook e Instagram activas, pero si no las tienes, lo configuramos en la primera sesión.",
  "phoenix.faq6Q": "¿Puedo hacer preguntas entre sesiones?",
  "phoenix.faq6A": "Sí, tendrás acceso directo a mí por WhatsApp para resolver dudas puntuales entre sesiones. Quiero asegurarme de que realmente implementes todo lo que aprendemos.",
  "phoenix.faq8Q": "¿Por qué solo 171 USD?",
  "phoenix.faq8A": "Porque mi objetivo es que más emprendedores puedan acceder a una mentoría de calidad sin que el precio sea una barrera. El valor real del programa supera los $500 USD. Es una inversión en tu educación y en el crecimiento de tu negocio.",

  "phoenix.finalTitle": "No compres otra mentoría.",
  "phoenix.finalSubtitle": "Invierte en un sistema que podrás utilizar durante toda tu carrera.",
  "phoenix.finalDesc": "Trabajaremos juntos sobre tu negocio para que termines con una estrategia clara, campañas configuradas y el conocimiento necesario para seguir creciendo.",
  "phoenix.finalPrice": "171 USD",
  "phoenix.finalCta": "Reservar mi Cupo",
  "phoenix.finalFeature1": "Mentoría Personalizada",
  "phoenix.finalFeature2": "Cupos Limitados",
  "phoenix.finalFeature3": "Acceso Inmediato",

  "trafficPro.badge": "🚀 Servicio Premium",
  "trafficPro.heroTitle": "Plan Traffic Pro",
  "trafficPro.heroHeadline": "Lanzamos tu primera campaña profesional para conseguir clientes con Meta Ads.",
  "trafficPro.heroSubtitle": "Construimos una estrategia publicitaria pensada para la forma en que Meta Ads funciona hoy. Diseñamos imágenes y videos con Inteligencia Artificial que captan la atención, configuramos correctamente tu ecosistema publicitario y te entregamos una campaña optimizada para generar más oportunidades de venta, mientras aprendes a interpretar las métricas para seguir creciendo.",
  "trafficPro.heroFeature1": "Configuración Profesional",
  "trafficPro.heroFeature2": "Campaña Lista para Publicar",
  "trafficPro.heroFeature3": "Optimización Inicial",
  "trafficPro.heroFeature4": "Seguimiento de Métricas",
  "trafficPro.ctaPrimary": "Quiero Lanzar mi Campaña",
  "trafficPro.ctaSecondary": "Ver Planes",
  "trafficPro.ctaWhatsApp": "Hablar por WhatsApp",
  "trafficPro.heroSpeedCTA": "Quiero mi campaña publicitaria en 2 días",
  "trafficPro.trust1": "Pago Seguro",
  "trafficPro.trust2": "Implementación Profesional",
  "trafficPro.trust3": "Entrega en 15 días",

  "trafficPro.includesTag": "¿Qué incluye Traffic Pro?",
  "trafficPro.includesTitle": "Tu Ecosistema Digital",
  "trafficPro.includesTitleHighlight": "Completo",
  "trafficPro.includes1": "Configuración del Business Manager",
  "trafficPro.includes1Desc": "Creamos y configuramos tu centro de operaciones empresarial en Meta.",
  "trafficPro.includes2": "Creación del Portafolio Empresarial",
  "trafficPro.includes2Desc": "Establecemos la identidad profesional de tu negocio dentro del ecosistema Meta.",
  "trafficPro.includes3": "Configuración de Cuenta Publicitaria",
  "trafficPro.includes3Desc": "Activamos tu cuenta publicitaria con todas las configuraciones necesarias.",
  "trafficPro.includes4": "Administrador de Anuncios",
  "trafficPro.includes4Desc": "Estructuramos el panel de control desde donde gestionarás tus campañas.",
  "trafficPro.includes5": "Configuración del Pixel",
  "trafficPro.includes5Desc": "Instalamos el pixel de seguimiento para medir conversiones y optimizar.",
  "trafficPro.includes6": "Creación de la Campaña",
  "trafficPro.includes6Desc": "Diseñamos tu campaña publicitaria con objetivos claros y estructura profesional.",
  "trafficPro.includes7": "Segmentación del Público",
  "trafficPro.includes7Desc": "Definimos las audiencias ideales para que tus anuncios lleguen a quien debe llegar.",
  "trafficPro.includes8": "Configuración de Conversiones",
  "trafficPro.includes8Desc": "Establecemos los eventos de conversión para medir resultados de forma precisa.",
  "trafficPro.includes9": "Optimización Inicial",
  "trafficPro.includes9Desc": "Ajustamos parámetros durante los primeros días para mejorar el rendimiento.",
  "trafficPro.includes10": "Revisión de Métricas",
  "trafficPro.includes10Desc": "Analizamos los datos y te entregamos un informe claro del desempeño.",
  "trafficPro.includes11": "Entrega del Proyecto",
  "trafficPro.includes11Desc": "Proyecto listo en Meta Ads.",

  "trafficPro.processTag": "Nuestro Proceso",
  "trafficPro.processTitle": "Cómo",
  "trafficPro.processTitleHighlight": "Trabajamos",
  "trafficPro.process1Title": "Diagnóstico",
  "trafficPro.process1Desc": "Analizamos tu negocio y objetivos.",
  "trafficPro.process2Title": "Configuración",
  "trafficPro.process2Desc": "Creamos toda la estructura profesional en Meta.",
  "trafficPro.process3Title": "Diseño",
  "trafficPro.process3Desc": "Creamos anuncios utilizando Inteligencia Artificial.",
  "trafficPro.process4Title": "Lanzamiento",
  "trafficPro.process4Desc": "Publicamos la campaña.",
  "trafficPro.process5Title": "Optimización",
  "trafficPro.process5Desc": "Revisamos métricas durante los siguientes días.",

  "trafficPro.pricingTag": "Elige tu Plan",
  "trafficPro.pricingTitle": "Inversión",
  "trafficPro.pricingTitleHighlight": "Para tu empresa",
  "trafficPro.planAName": "Plan A",
  "trafficPro.planAPrice": "137 USD",
  "trafficPro.planAUsd": "60 USD",
  "trafficPro.planADesc": "Ideal para quienes desean comenzar.",
  "trafficPro.planAItem1": "Configuración completa del ecosistema Meta",
  "trafficPro.planAItem2": "Campaña Profesional",
  "trafficPro.planAItem3": "4 imágenes y videos creadas con Inteligencia Artificial",
  "trafficPro.planAItem4": "Optimización inicial",
  "trafficPro.planAItem5": "Revisión de métricas",
  "trafficPro.planATimeline": "2 a 5 días de implementación. 10 días de seguimiento.",
  "trafficPro.planBName": "Plan B",
  "trafficPro.planBPrice": "300.000 COP",
  "trafficPro.planBUsd": "84 USD",
  "trafficPro.planBDesc": "La opción más completa para máximo impacto.",
  "trafficPro.planBItem1": "Todo lo del Plan A",
  "trafficPro.planBItem2": "4 Videos creados con IA",
  "trafficPro.planBItem3": "2 Imágenes IA adicionales",
  "trafficPro.planBItem4": "Creativos Premium",
  "trafficPro.planBItem5": "Mayor impacto visual",
  "trafficPro.planBTimeline": "2 a 5 días de implementación. 10 días de seguimiento.",
  "trafficPro.popularBadge": "Más Popular",
  "trafficPro.planACta": "Contactános",
  "trafficPro.planBCta": "Elegir Plan B",

  "trafficPro.howTag": "¿Cómo Trabajaremos?",
  "trafficPro.howTitle": "Proceso de",
  "trafficPro.howTitleHighlight": "Colaboración",
  "trafficPro.how1Title": "50% para iniciar",
  "trafficPro.how1Desc": "Realizas el primer pago para comenzar con la implementación del ecosistema digital.",
  "trafficPro.how2Title": "50% al finalizar",
  "trafficPro.how2Desc": "El pago restante se realiza cuando todo el proyecto esté entregado y funcionando.",
  "trafficPro.how3Title": "Entrega profesional",
  "trafficPro.how3Desc": "Recibes acceso a todo el ecosistema configurado con documentación detallada.",
  "trafficPro.how4Title": "Seguimiento incluido",
  "trafficPro.how4Desc": "Después de la entrega, realizamos seguimiento de métricas durante 10 días.",
  "trafficPro.how5Title": "Comunicación directa",
  "trafficPro.how5Desc": "Canal de comunicación abierto para resolver dudas durante todo el proceso.",

  "trafficPro.whyTag": "¿Por Qué Elegirnos?",
  "trafficPro.whyTitle": "Ventajas",
  "trafficPro.whyTitleHighlight": "Estratégicas",
  "trafficPro.why1Title": "Marketing Estratégico",
  "trafficPro.why1Desc": "Cada campaña se basa en un análisis profundo de tu negocio y mercado objetivo.",
  "trafficPro.why2Title": "Meta Ads Profesional",
  "trafficPro.why2Desc": "Configuración experta con las mejores prácticas y estándares de la industria.",
  "trafficPro.why3Title": "Creativos con IA",
  "trafficPro.why3Desc": "Imágenes y videos generados con inteligencia artificial de última generación.",
  "trafficPro.why4Title": "Optimización",
  "trafficPro.why4Desc": "Monitoreo y ajustes continuos para mejorar el rendimiento de tu inversión.",
  "trafficPro.why5Title": "Análisis de Métricas",
  "trafficPro.why5Desc": "Interpretamos los datos para tomar decisiones informadas sobre tus campañas.",
  "trafficPro.why6Title": "Automatización",
  "trafficPro.why6Desc": "Implementamos sistemas que trabajan por ti incluso mientras duermes.",

  "trafficPro.resultsTag": "Resultados Esperados",
  "trafficPro.resultsTitle": "Lo Que",
  "trafficPro.resultsTitleHighlight": "Lograrás",
  "trafficPro.results1": "Mayor visibilidad",
  "trafficPro.results2": "Más clientes potenciales",
  "trafficPro.results3": "Campañas estructuradas",
  "trafficPro.results4": "Mejor organización",
  "trafficPro.results5": "Decisiones basadas en datos",
  "trafficPro.results6": "Escalabilidad",

  "trafficPro.faqTag": "Preguntas Frecuentes",
  "trafficPro.faq1Q": "¿Qué es exactamente Traffic Pro Launch?",
  "trafficPro.faq1A": "Traffic Pro Launch es un servicio premium donde configuramos desde cero todo el ecosistema de Meta Ads para tu negocio: Business Manager, cuenta publicitaria, pixel, campaña profesional y optimización inicial. No es solo crear anuncios, es construir un sistema digital completo preparado para atraer clientes de forma constante.",
  "trafficPro.faq2Q": "¿Cuánto tiempo toma ver resultados?",
  "trafficPro.faq2A": "La implementación completa toma de 2 a 5 días hábiles. Una vez publicada la campaña, realizamos seguimiento de métricas durante 10 días. Los primeros resultados comienzan a verse desde los primeros días de publicación, pero recomendamos esperar al menos 7 días para tener datos significativos que permitan optimizar.",
  "trafficPro.faq3Q": "¿Necesito tener experiencia previa con Meta Ads?",
  "trafficPro.faq3A": "No. Traffic Pro Launch está diseñado precisamente para dueños de negocio que quieren tener presencia profesional en Meta Ads sin tener que aprender toda la parte técnica. Nosotros nos encargamos de todo y te entregamos el ecosistema listo y documentado.",
  "trafficPro.faq4Q": "¿Qué incluyen las imágenes y videos creados con IA?",
  "trafficPro.faq4A": "Creamos creativos publicitarios profesionales utilizando inteligencia artificial. En el Plan incluimos 2 imágenes y 3 videos con IA optimizadas para Meta Ads, todos diseñados para captar la atención de tu audiencia ideal y generar conversiones.",
  "trafficPro.faq5Q": "¿Qué pasa si no tengo página web o redes sociales?",
  "trafficPro.faq5A": "No hay problema. Podemos trabajar con lo que tengas. Si no tienes página web, podemos configurar las campañas orientadas a conversiones en WhatsApp o Messenger. Si necesitas una página web, también ofrecemos ese servicio por separado.",
  "trafficPro.faq6Q": "¿Cómo funciona el pago del 50% inicial y 50% final?",
  "trafficPro.faq6A": "Realizas el primer pago del 50% para iniciar el proyecto. Una vez completada la implementación, revisamos juntos todo el trabajo realizado y realizas el 50% restante. Esto te da tranquilidad y confianza en el proceso.",
  "trafficPro.faq7Q": "¿Tengo control total de mis cuentas publicitarias?",
  "trafficPro.faq7A": "Sí, absolutamente. Todas las cuentas se crean a nombre de tu negocio y tú eres el propietario. Nosotros solo necesitamos acceso como socios o administradores durante el proceso de configuración y optimización. Al finalizar, tú tienes control total.",
  "trafficPro.faq8Q": "¿Qué sucede después de los 10 días de seguimiento?",
  "trafficPro.faq8A": "Después del período de seguimiento, te entregamos un informe detallado con todas las métricas, recomendaciones y aprendizajes. Si deseas continuar con gestión mensual de campañas, podemos ofrecerte nuestro servicio Traffic Master, diseñado para administración continua.",

  "trafficPro.finalTitle": "Tu próxima campaña puede ser la diferencia entre seguir buscando clientes o empezar a atraerlos de forma constante.",
  "trafficPro.finalSubtitle": "Comencemos construyendo un ecosistema digital profesional para tu negocio.",

  "trafficPro.kpiRoas": "ROAS",
  "trafficPro.kpiLeads": "Leads",
  "trafficPro.kpiCtr": "CTR",
  "trafficPro.kpiConversions": "Conversiones",

  "trafficMaster.badge": "🚀 Servicio Empresarial Premium",
  "trafficMaster.heroTitle": "Traffic Master Growth™",
  "trafficMaster.heroHeadline": "Tu Departamento de Marketing Digital sin contratar un equipo interno.",
  "trafficMaster.heroSubtitle": "Nos convertimos en el aliado estratégico de tu empresa para crear campañas con seguimiento, contenido para Meta Ads todo el mes y un sistema comercial diseñado para generar clientes de forma constante.",
  "trafficMaster.heroSubtitle2": "No administramos anuncios. Construimos un ecosistema completo de crecimiento.",
  "trafficMaster.heroFeature1": "Campañas ilimitadas",
  "trafficMaster.heroFeature2": "Estrategia Continua",
  "trafficMaster.heroFeature3": "Optimización Semanal",
  "trafficMaster.heroFeature4": "Crecimiento Escalable",
  "trafficMaster.ctaPrimary": "Agenda una Consultoría",
  "trafficMaster.ctaSecondary": "Ver Todo lo que Incluye",
  "trafficMaster.trust1": "Servicio Empresarial",
  "trafficMaster.trust2": "Implementación Profesional",
  "trafficMaster.trust3": "Soporte Continuo",
  "trafficMaster.heroKpiRoas": "ROAS",
  "trafficMaster.heroKpiRevenue": "Ingresos",
  "trafficMaster.heroKpiLeads": "Leads",
  "trafficMaster.heroKpiGrowth": "Crecimiento Semanal",

  "trafficMaster.servicesTag": "Más que una agencia",
  "trafficMaster.servicesTitle": "Somos tu departamento",
  "trafficMaster.servicesTitleHighlight": "de marketing",
  "trafficMaster.svc1Title": "Campañas Ilimitadas",
  "trafficMaster.svc1Desc": "Creamos y optimizamos campañas constantemente para maximizar el retorno de tu inversión publicitaria.",
  "trafficMaster.svc2Title": "Marketing de Contenidos",
  "trafficMaster.svc2Desc": "Parrilla de contenido semanal, con 5 piezas gráficas para tres redes sociales a la semana.",
  "trafficMaster.svc3Title": "Sitio Web Profesional",
  "trafficMaster.svc3Desc": "Construimos tu página web utilizando la plataforma recomendada para obtener el mejor rendimiento.",
  "trafficMaster.svc4Title": "Automatización",
  "trafficMaster.svc4Desc": "Integramos procesos inteligentes para ahorrar tiempo y mejorar la conversión de forma sistemática.",
  "trafficMaster.svc5Title": "Optimización Semanal",
  "trafficMaster.svc5Desc": "Analizamos las métricas semanalmente y realizamos mejoras continuas basadas en datos reales.",
  "trafficMaster.svc6Title": "Consultoría Estratégica",
  "trafficMaster.svc6Desc": "Te acompañamos en la toma de decisiones estratégicas para escalar tu negocio de forma sostenible.",

  "trafficMaster.ecosystemTag": "Nuestro Ecosistema de Crecimiento",
  "trafficMaster.ecosystemTitle": "Un sistema completo para",
  "trafficMaster.ecosystemTitleHighlight": "escalar tu empresa",
  "trafficMaster.eco1": "Estrategia de Negocio",
  "trafficMaster.eco2": "Investigación de Clientes",
  "trafficMaster.eco3": "Meta Ads",
  "trafficMaster.eco4": "Sitio Web",
  "trafficMaster.eco5": "Landing Pages",
  "trafficMaster.eco6": "Automatización",
  "trafficMaster.eco7": "CRM",
  "trafficMaster.eco8": "Nutrición de Leads",
  "trafficMaster.eco9": "Ventas",
  "trafficMaster.eco10": "Fidelización",

  "trafficMaster.monthlyTag": "Entregables Mensuales",
  "trafficMaster.monthlyTitle": "¿Qué recibirás cada mes?",
  "trafficMaster.del1": "Campañas Publicitarias Ilimitadas",
  "trafficMaster.del2": "20 Publicaciones Mensuales",
  "trafficMaster.del3": "Gestión de 2 Redes Sociales",
  "trafficMaster.del4": "Diseño de Anuncios",
  "trafficMaster.del5": "Optimización Continua",
  "trafficMaster.del6": "Lectura Semanal de Métricas",
  "trafficMaster.del7": "Asesoría Estratégica",
  "trafficMaster.del8": "Sitio Web Profesional",
  "trafficMaster.del9": "Automatización Comercial",
  "trafficMaster.del10": "Reportes Semanal",

  "trafficMaster.processTag": "Nuestro Proceso",
  "trafficMaster.processTitle": "Cómo trabajamos para hacer crecer tu empresa",
  "trafficMaster.stepLabel": "PASO",
  "trafficMaster.process1": "Diagnóstico Empresarial",
  "trafficMaster.process1Item1": "Analizamos tus objetivos de negocio",
  "trafficMaster.process1Item2": "Identificamos oportunidades de crecimiento",
  "trafficMaster.process2": "Diseño Estratégico",
  "trafficMaster.process2Item1": "Creamos el plan de crecimiento personalizado",
  "trafficMaster.process2Item2": "Definimos KPIs y métricas de éxito",
  "trafficMaster.process3": "Implementación",
  "trafficMaster.process3Item1": "Lanzamos campañas publicitarias",
  "trafficMaster.process3Item2": "Mejoramos tus cuentas en Meta Ads",
  "trafficMaster.process3Item3": "Configuramos la automatización comercial",
  "trafficMaster.process4": "Optimización",
  "trafficMaster.process4Item1": "Lectura semanal de métricas",
  "trafficMaster.process4Item2": "Ajustes basados en datos reales",
  "trafficMaster.process5": "Escalamiento",
  "trafficMaster.process5Item1": "Nuevas campañas de crecimiento",
  "trafficMaster.process5Item2": "Mejoras continuas del ecosistema",

  "trafficMaster.resultsTag": "Resultados Esperados",
  "trafficMaster.resultsTitle": "Resultados que buscamos conseguir juntos",
  "trafficMaster.result1": "Mayor Visibilidad",
  "trafficMaster.result2": "Más Clientes Potenciales",
  "trafficMaster.result3": "Mejor ROAS",
  "trafficMaster.result4": "Mayor Posicionamiento",
  "trafficMaster.result5": "Más Ventas",
  "trafficMaster.result6": "Automatización Total",
  "trafficMaster.result7": "Escalabilidad",

  "trafficMaster.idealTag": "Ideal para",
  "trafficMaster.idealTitle": "Empresas que quieren crecer de forma constante",
  "trafficMaster.ideal1": "Empresas en Crecimiento",
  "trafficMaster.ideal2": "Marcas Personales",
  "trafficMaster.ideal3": "E-commerce",
  "trafficMaster.ideal4": "Empresas de Servicios",
  "trafficMaster.ideal5": "Constructoras",
  "trafficMaster.ideal6": "Clínicas",
  "trafficMaster.ideal7": "Restaurantes",
  "trafficMaster.ideal8": "Academias",
  "trafficMaster.ideal9": "Inmobiliarias",

  "trafficMaster.comparisonTag": "Comparación",
  "trafficMaster.comparisonTitle": "¿Por qué Traffic Master Growth™?",
  "trafficMaster.compFeature": "Característica",
  "trafficMaster.compTraditional": "Agencia Tradicional",
  "trafficMaster.comp1": "Campañas ilimitadas",
  "trafficMaster.comp2": "Optimización semanal",
  "trafficMaster.comp3": "Consultoría estratégica",
  "trafficMaster.comp4": "Sitio web incluido",
  "trafficMaster.comp5": "Automatización comercial",
  "trafficMaster.comp6": "Sistema de crecimiento empresarial",

  "trafficMaster.pricingTag": "Inversión",
  "trafficMaster.pricingTitle": "Inversión en crecimiento empresarial",
  "trafficMaster.pricingWeekly": "Inversión semanal",
  "trafficMaster.pricingWeeklyAmount": "118 USD",
  "trafficMaster.pricingEquivalent": "Equivalente a",
  "trafficMaster.pricingMonthly": "470 USD",
  "trafficMaster.pricingMonthlyUsd": "mensuales",
  "trafficMaster.pricingHighlight": "Ideal para empresas que desean crecer de forma constante",
  "trafficMaster.pricingCta": "Agenda una Consultoría Estratégica",

  "trafficMaster.faqTag": "Preguntas Frecuentes",
  "trafficMaster.faqTitle": "Resolvemos tus dudas",
  "trafficMaster.faq1Q": "¿Qué es exactamente Traffic Master Growth™?",
  "trafficMaster.faq1A": "Traffic Master Growth™ es nuestro servicio empresarial premium donde nos convertimos en tu departamento de marketing externo. No solo administramos anuncios — construimos un ecosistema completo que incluye campañas ilimitadas, creación de contenido, optimización continua y consultoría estratégica. Es como tener un CMO y un equipo de marketing trabajando exclusivamente para tu empresa, sin los costos de contratar personal interno.",
  "trafficMaster.faq2Q": "¿Cuál es la diferencia entre Traffic Pro y Traffic Master?",
  "trafficMaster.faq2A": "Traffic Pro es un servicio puntual donde configuramos tu ecosistema Meta Ads y lanzamos tu primera campaña profesional. Traffic Master es un servicio continuo de gestión mensual donde nos convertimos en tu departamento de marketing: campañas ilimitadas, contenido, optimización semanal y consultoría estratégica permanente.",
  "trafficMaster.faq3Q": "¿Qué incluyen exactamente las campañas ilimitadas?",
  "trafficMaster.faq3A": "Creamos, lanzamos y optimizamos todas las campañas publicitarias que sean necesarias para alcanzar los objetivos de tu empresa. Esto incluye campañas de prospección, retargeting, conversión. No hay límite en la cantidad de campañas activas.",
  "trafficMaster.faq4Q": "¿En qué redes sociales publican el contenido?",
  "trafficMaster.faq4A": "Trabajamos en las dos redes sociales que mejor se adapten a tu negocio y audiencia objetivo. Generalmente Instagram y Facebook, pero podemos trabajar en TikTok u otras plataformas según tu estrategia. Publicamos 20 contenidos mensuales con diseño profesional.",
  "trafficMaster.faq5Q": "¿Cómo funciona la optimización semanal?",
  "trafficMaster.faq5A": "Cada semana analizamos las métricas de todas las campañas activas, el rendimiento y los resultados comerciales. Con base en estos datos, realizamos ajustes estratégicos para mejorar continuamente el ROAS, reducir costos de adquisición y aumentar la generación de clientes.",
  "trafficMaster.faq6Q": "¿Qué tipo de empresas son ideales para Traffic Master?",
  "trafficMaster.faq6A": "Traffic Master está diseñado para empresas que ya tienen cierto nivel de operación y desean escalar de forma constante y profesional. Es ideal para empresas en crecimiento, marcas personales establecidas, e-commerce, constructoras, clínicas, restaurantes, academias, inmobiliarias y empresas de servicios que buscan un sistema de crecimiento predecible.",
  "trafficMaster.faq7Q": "¿Hay un contrato de permanencia mínimo?",
  "trafficMaster.faq7A": "Recomendamos un compromiso mínimo de 3 meses para poder construir, optimizar y empezar a ver resultados consistentes. El marketing digital es un proceso que requiere tiempo para madurar. Sin embargo, trabajamos con pagos mensuales sin cláusulas de permanencia forzosa.",
  "trafficMaster.faq8Q": "¿Quién maneja mi cuenta publicitaria y mi sitio web?",
  "trafficMaster.faq8A": "Todas las cuentas y activos digitales se crean a nombre de tu empresa. Tú eres el propietario absoluto. Nuestro equipo opera como administradores durante la vigencia del servicio. Si en algún momento decides terminar la relación, te entregamos todo con acceso completo y sin restricciones.",

  "trafficMaster.finalTag": "Crece con un sistema, no con suerte",
  "trafficMaster.finalTitle": "No necesitas contratar un departamento de marketing.",
  "trafficMaster.finalTitleHighlight": "Necesitas un sistema que haga crecer tu empresa.",
  "trafficMaster.finalSubtitle": "Traffic Master Growth™ combina estrategia, publicidad, contenido, automatización y análisis para ayudarte a conseguir clientes de forma constante.",
  "trafficMaster.finalCtaPrimary": "Agenda una Consultoría",
  "trafficMaster.finalCtaWhatsApp": "Hablar por WhatsApp",
};

export default common;